if (!customElements.get('bg-tray-fit')) {
  customElements.define('bg-tray-fit', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const form = this.querySelector('[data-fit-form]');
      const result = this.querySelector('[data-fit-result]');
      if (!form || !result) return;
      form.hidden = false;
      result.hidden = false;
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const width = Number(form.elements.equipmentWidth.value);
        const depth = Number(form.elements.equipmentDepth.value);
        const border = Number(form.elements.border.value);
        if (!form.checkValidity() || ![width, depth, border].every(Number.isFinite) || width <= 0 || depth <= 0 || border < 0) {
          result.textContent = this.dataset.invalid;
          return;
        }
        const neededWidth = width + 2 * border;
        const neededDepth = depth + 2 * border;
        const matches = Array.from(this.querySelectorAll('[data-tray-width]')).filter((row) => Number(row.dataset.trayWidth) >= neededWidth && Number(row.dataset.trayDepth) >= neededDepth);
        result.replaceChildren();
        const summary = document.createElement('p');
        summary.textContent = this.dataset.result.replace('[width]', Number(neededWidth.toFixed(3))).replace('[depth]', Number(neededDepth.toFixed(3)));
        result.append(summary);
        const label = document.createElement('p');
        label.textContent = matches.length ? this.dataset.match : this.dataset.noMatch;
        result.append(label);
        if (matches.length) {
          const list = document.createElement('ul');
          matches.forEach((row) => {
            const item = document.createElement('li');
            const link = document.createElement('a');
            link.href = row.dataset.trayUrl;
            link.textContent = row.dataset.trayName + ' · ' + row.dataset.trayWidth + ' × ' + row.dataset.trayDepth + ' in';
            item.append(link);
            list.append(item);
          });
          result.append(list);
        }
      });
    }
  });
}
